import { CategoryRequestStatus } from '../types';

export const categoryRequestStatusTabs: {
  value: CategoryRequestStatus;
  label: string;
}[] = [
  { value: 'PENDING', label: 'Pending' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'DECLINED', label: 'Declined' },
  { value: 'CANCELLED', label: 'Cancelled' },
];

export const categoryRequestStatusColor: Record<CategoryRequestStatus, string> =
  {
    PENDING: 'bg-yellow-500',
    APPROVED: 'bg-green-500',
    DECLINED: 'bg-red-500',
    CANCELLED: 'bg-gray-400',
  };

export const categoryRequestsColumns = [
  {
    Header: 'Request name',
    accessor: 'name',
    Cell: ({ row }: any) => (
      <div className="flex items-center gap-3">
        {row.original.imageUrl ? (
          <img
            src={row.original.imageUrl}
            alt={row.original.name}
            className="h-8 w-8 rounded object-cover bg-slate-mild flex-shrink-0"
          />
        ) : (
          <div className="h-8 w-8 rounded bg-slate-mild flex-shrink-0" />
        )}
        <span className="text-sm text-text">{row.original.name}</span>
      </div>
    ),
  },
  { Header: 'Vendor', accessor: 'brandName' },
  { Header: 'Type', accessor: 'type' },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ row }: any) => (
      <div className="flex items-center">
        <div
          className={`h-2 w-2 rounded-full mr-2 ${
            row.original.statusColor || 'bg-gray-400'
          }`}
        />
        <span className="text-sm text-text">{row.original.status}</span>
      </div>
    ),
  },
  { Header: 'Requested', accessor: 'createdAtDisplay' },
];
